'use client';

import './password-requirements.scss';

import { useTranslation } from 'react-i18next';

import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';

import { PASSWORD_CHECKS, passwordValidator } from '../../utils/helpers.ts';

interface PasswordRequirements {
  value: string;
}

export const PasswordRequirements = ({ value }: PasswordRequirements) => {
  const { t } = useTranslation(['auth']);

  const passwordResults = passwordValidator.safeParse(value);
  const issues = passwordResults.error?.issues;

  return (
    <ul className="PasswordRequirements flex flex-col gap-snug-xl p-none">
      {Object.values(PASSWORD_CHECKS).map((label) => {
        const isValid = !issues?.find((i) => i.message === label);
        return (
          <li
            key={label}
            data-valid={isValid}
            className="PasswordRequirements__criteria flex items-center gap-comfy-xs"
          >
            {isValid ? (
              <ArkIcon
                iconName="check-circle"
                className="PasswordRequirements__checkIcon"
              />
            ) : (
              <ArkIcon iconName="circle" />
            )}
            <p className="PasswordRequirements__criteria">
              {t(`auth:box.form.validation.${label}`)}
            </p>
          </li>
        );
      })}
    </ul>
  );
};
